import React, {Component} from 'react';
import {connect} from "react-redux";
import axios from 'axios';

import {
  openMapEditor as openMapEditorAction,
  closeMapEditor as closeMapEditorAction,
  saveScenarioMap as saveScenarioMapAction,
  fetchScenarios as fetchRepoScenariosAction,
  selectScenario as selectScenarioAction,
} from './ScenariosActions';
import PropTypes from "prop-types";

import helpers from "../../helpers";

class MapEditor extends Component {
  constructor() {
    super();
    this.close = this.close.bind(this);
    this.saveClose = this.saveClose.bind(this);
    this.fileUpload = this.fileUpload.bind(this);
    this.drag = this.drag.bind(this);
    this.dragStart = this.dragStart.bind(this);
    this.dragEnd = this.dragEnd.bind(this);

    this.draggingPointI = -1;
    this.dragStartCoords = {x: 0, y: 0};
    this.dragStartPointPosition = {left: 0, top: 0};
    this.state = {mapImageSrc: '', image_src: '', is_uploaded_image: false,
      locations: []}
  }

  close() {
    this.props.closeMapEditor()
  }

  componentDidUpdate() {
    if (this.props.scenario.mapInfo && this.props.scenario.mapInfo.image) {
      let mapImageSrc = this.props.scenario.archiveURL.split('/').slice(0, -1).join('/')+'/files/'+ this.props.scenario.mapInfo.image;
      if (mapImageSrc !== this.state.image_src && !this.state.is_uploaded_image) {
        this.setState({
          ...this.state,
          image_src: mapImageSrc
        })
      }
    }
    let mapInfoLocationsDict = {};
    if (this.props.scenario.mapInfo) {
      this.props.scenario.mapInfo.locations.forEach(l => mapInfoLocationsDict[l.id] = {name: l.name, id: l.id, top: parseFloat(l.top), left: parseFloat(l.left)});
    }

    if (this.state.locations.length === 0 && this.props.scenario.locations) {
      let locations_libs = {};
      this.setState({
        ...this.state,
        locations: this.props.scenario.locations.filter(l => {
          if (locations_libs[l.name]) {
            return false;
          } else {
            locations_libs[l.name] = true;
            return true;
          }
        }).map((l, i) => {
          let id = l.name.replaceAll(' ', '');
            if (mapInfoLocationsDict[id]) {
              return mapInfoLocationsDict[id];
            }
            else {
              return {name: l.name, id, top: 0, left: i * 5}
            }
        })
      })
    }
  }

  saveClose() {
    this.props.saveScenarioMap(this.props.companyId, /* this.props.scenario._id */ this.props.currentScenario, this.mapImage, this.state.locations);
    this.close();
  }

  fileUpload(event) {
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();

      reader.onload = (e) => {
        this.setState({
          ...this.state,
          image_src: e.target.result,
          is_uploaded_image: true,
        });
      }
      reader.readAsDataURL(event.target.files[0]); // convert to base64 string
      this.mapImage = event.target.files[0];
    }
  }

  dragStart(e, i) {
    this.draggingPointI = i;
    this.dragStartCoords.x = e.pageX;
    this.dragStartCoords.y = e.pageY;
    this.dragStartPointPosition.left = this.state.locations[i].left;
    this.dragStartPointPosition.top = this.state.locations[i].top;

    window.addEventListener('mousemove', this.drag);
    window.addEventListener('mouseup', this.dragEnd);
  }

  drag(e) {
    let imgElm = document.getElementById('map_editor_img');
    let rect = imgElm.getBoundingClientRect();
    this.state.locations[this.draggingPointI].left = Math.max(0, Math.min(100, this.dragStartPointPosition.left + (e.pageX - this.dragStartCoords.x) / rect.width * 100));
    this.state.locations[this.draggingPointI].top = Math.max(0, Math.min(100, this.dragStartPointPosition.top + (e.pageY - this.dragStartCoords.y) / rect.height * 100));

    this.setState({
      ...this.state
    })
  }

  dragEnd(e) {
    window.removeEventListener('mousemove', this.drag);
    window.removeEventListener('mouseup', this.dragEnd);
  }
  
  handleRemoveMap = async () => {
    const confirmation = confirm("Are you sure you want to remove this map");
    if(!confirmation) return;
    try {
      const user = helpers.getUserFromLocalStorage();
      // const response = await axios.delete(`/api/scenarios/${user.company._id}/${this.props.scenario._id}/deletemap`, {
      const response = await axios.delete(`/api/scenarios/${user.company._id}/${this.props.currentScenario}/deletemap`, {
        headers: {
          'Authorization': localStorage.getItem("token"),
        }
      });
      if(response.status === 400) {
        return alert(response.data);
      }
      this.close()
      this.props.fetchScenarios();
      this.props.selectScenario({_id: this.props.scenario._id, mapInfo: undefined});
    } catch (err) {
      console.error(err);
    }
  }

  render() {
    const {title, id, is_public, description, keywords, lastChange} = this.props.scenario;
    const currentScenario = this.props.currentScenario;

    return (<div className="map_editor">
      <div className="map_editor__window" style={this.state.image_src? {minWidth: 'unset'} : {}}>
        {this.state.locations.map((l, i) => <div onMouseDown={(e) => this.dragStart(e, i)}
                                                 title={l.name + ' [' + l.state + ']'} key={'map_point-' + l.id}
                                                 className="map_point" style={{left: l.left + '%', top: l.top + '%'}}>
          {l.name}
          {l.state && <i>{l.state}</i>}
        </div>)}
        <img
          id="map_editor_img" 
          src={
            (() => {
              let mapImageSrc = this.state.image_src.startsWith("data:") || this.state.image_src.startsWith("https:")? this.state.image_src : (this.props.scenario.mapInfo?.image || "");
              console.log("MAP IMAGE SRC", mapImageSrc, {state: this.state.image_src, mapInfoProp: this.props.scenario.mapInfo});
              if(this.props.scenario.store === 'LOCAL' && mapImageSrc && !mapImageSrc.startsWith("data:")) {
                // const imgPath = mapImageSrc.split("/");
                // const imageName = imgPath[imgPath.length - 1];
                // mapImageSrc = "/api/image/" + this.props.companyId + '/' + this.props.scenario.uniqueId + '/' + imageName;
                mapImageSrc = "/api/image/" + this.props.companyId + '/' + this.props.scenario.uniqueId + '/' + this.props.scenario.mapInfo.image;
              }
              return mapImageSrc;
            })()
          }
        />
        <div style={{display: 'flex', justifyContent: 'space-between'}}>
          {
            this.props.currentScenarioMapInfo &&
            <div className="btn btn-danger" onClick={this.handleRemoveMap}>Remove Map</div>
          }
          <div className="map_editor__window_controls btn-group">
            <input onChange={this.fileUpload} type="file" accept=".jpg,.jpeg,.gif,.png,.bmp" id="map_image_input"/>
            <label htmlFor="map_image_input" className="btn btn-default">Upload new image</label>
            <div className="btn btn-default" onClick={this.close}>Close</div>
            <div className="btn btn-primary" onClick={this.saveClose}>Save</div>
          </div>
        </div>
      </div>
      <div className="map_editor__bg"></div>
    </div>)
  }
}


MapEditor.propTypes = {
  scenario: PropTypes.object,
  closeMapEditor: PropTypes.func,
  companyId: PropTypes.string,
  saveScenarioMap: PropTypes.func,
  currentScenario: PropTypes.object,
};

const mapStateToProps = state => ({
  scenario: state.scenario.data, // NOTE: this is always empty for some reason
  currentScenarioMapInfo: state.scenarios.currentScenarioMapInfo,
  currentScenario: state.scenarios.currentScenario,
});

const mapDispatchToProps = {
  closeMapEditor: closeMapEditorAction,
  saveScenarioMap: saveScenarioMapAction,
  fetchScenarios: fetchRepoScenariosAction,
  selectScenario: selectScenarioAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MapEditor);
